import { useState, useCallback, useEffect } from 'react';
import { useVipage } from '../../../../../hooks/useVipage'; 
import { UseCardTransitionModalProps } from './types';

export function useCardTransitionModal({ 
  clientId, 
  cardNumber, 
  isOpen,
  onSuccess, 
  onClose 
}: UseCardTransitionModalProps) {
  const [currentStep, setCurrentStep] = useState<1 | 2>(1);
  const [selectedProductId, setSelectedProductId] = useState<number | string | null>(null);
  
  const { brandCardTransition, loadingVipagem } = useVipage();

  useEffect(() => {
    if (isOpen) {
      setSelectedProductId(null);
      setCurrentStep(1);
    }
  }, [isOpen]);

  const handleNextStep = useCallback(() => {
    if (selectedProductId) setCurrentStep(2);
  }, [selectedProductId]);

  const handlePrevStep = useCallback(() => {
    setCurrentStep(1);
  }, []);

  const handleConfirm = useCallback(async () => {
    if (!selectedProductId) return;

    const success = await brandCardTransition({
      clientId,
      productId: selectedProductId,
      cardNumber,
    });

    if (success) {
      if (onSuccess) await onSuccess();
      onClose();
    }
  }, [clientId, selectedProductId, cardNumber, brandCardTransition, onSuccess, onClose]);

  const handleClose = useCallback(() => {
    setCurrentStep(1);
    setSelectedProductId(null);
    onClose();
  }, [onClose]);

  return {
    currentStep,
    selectedProductId,
    setSelectedProductId,
    isLoading: loadingVipagem, 
    handleNextStep,
    handlePrevStep,
    handleConfirm,
    handleClose,
  };
}